export const parsePhone = (phone: string) => {
  return phone.replace('+7', '').replace('-', '').replace(' ', '');
};
